import React, { useEffect, useState } from "react";
import SimpleInput from "./../../SimpleInput";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import forntSideUplaod from "src/assets/images/front-side-light-blue.png";
import { ICustomerVerificationGet } from "src/types/GlobalInterfaces";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import { useNavigate } from "react-router-dom";

type typeOfStatus = "verified" | "non-verified" | "pending" | "declined";

const CustomerVerification: React.FC<{ userId: string }> = ({ userId }) => {
  const navigate = useNavigate();
  const [getLoader, setgetLoader] = useState<boolean>(false);
  const [currentStatus, setCurrentStatus] =
    useState<typeOfStatus>("non-verified");
  const [data, setData] = useState<ICustomerVerificationGet | null>(null);
  const fetch = async () => {
    setgetLoader(true);
    const { res, err } = await httpRequest<{
      data: ICustomerVerificationGet | null;
      status?: typeOfStatus;
    }>({ path: `/customer-verification/getVerifictaionRequest/${userId}` });
    if (res) {
      if (res?.data) setData(res.data);
      setCurrentStatus(res?.status || "non-verified");
    } else {
      toast(err, { type: "error" });
    }
    setgetLoader(false);
  };

  const [isLoader, setIsLoader] = useState<"approved" | "declined" | null>(
    null
  );
  const handleRequestActions = async (
    status: "approved" | "declined",
    id: string
  ) => {
    setIsLoader(status);
    const { res, err } = await httpRequest<{
      message: string;
      status: typeOfStatus;
    }>({
      method: "post",
      path: `/customer-verification/approve/decline/${id}`,
      params: { status },
    });
    if (res) {
      toast(res?.message || "Success!", { type: "success" });
      setCurrentStatus(res?.status || "non-verified");
      navigate(-1);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(null);
  };

  useEffect(() => {
    if (userId) {
      fetch();
    }
  }, [userId]);

  const ImageBox = (val: string, image: null | string): JSX.Element => {
    return (
      <>
        <div className="product-image-upload-new-add">
          <div
            className={`upload-label-visa-status img-verfification-change upload-label-visa-status-my relative`}
          >
            {image ? (
              <img
                src={`${image}`}
                alt="Product"
                className={`uploaded-image`}
              />
            ) : (
              <div className="upload-placeholder-visa-status">
                <div className="flex justify-center gap-2 items-center">
                  <img src={forntSideUplaod} />
                  <span className="text-[#707070] font-Poppins-Medium font-size-15px">
                    {val}
                  </span>
                </div>
                <p className="text-[#707070] font-Poppins-Medium font-size-15px">
                  Drag and Drop Here or{" "}
                  <span className="theme-color-green">Browse files</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };
  const validateDay = (value: string): boolean => {
    const day = parseInt(value, 10);
    return !isNaN(day) && day >= 1 && day <= 31;
  };

  const validateMonth = (value: string): boolean => {
    const month = parseInt(value, 10);
    return !isNaN(month) && month >= 1 && month <= 12;
  };

  const validateYear = (value: string): boolean => {
    const year = parseInt(value, 10);
    const currentYear = new Date().getFullYear();
    return !isNaN(year) && year >= currentYear;
  };
  return (
    <>
      {getLoader && ""}
      <div className="products-tabs-content-main">
        <div className="products-tabs-content">
          <div className="flex justify-between">
            <h3 className="text-[#1C1C1C] font-Poppins-Medium font-size-18px">
              Visa Status
            </h3>
            {currentStatus === "pending" ? (
              <span className="Verification-pending font-Poppins-Medium font-size-16px">
                Verification pending
              </span>
            ) : currentStatus === "verified" ? (
              <span className="Verification-done font-Poppins-Medium font-size-16px">
                Verified
              </span>
            ) : currentStatus === "declined" ? (
              <span className="Verification-declined font-Poppins-Medium font-size-16px">
                Declined
              </span>
            ) : (
              ""
            )}
          </div>
          <div className="vise-status-detail">
            {data?.type === "resident" ? (
              <>
                {ImageBox("Front Side", data?.frontImage || "")}
                {ImageBox("Back Side", data?.backImage || "")}
              </>
            ) : (
              ImageBox("Passport", data?.uploadPassportIdImage || "")
            )}
          </div>
          <SimpleInput
            type="text"
            isLabel={true}
            labelText="Type"
            isRequired={false}
            value={data?.type || ""}
            onChange={() => {}}
            disabled={true}
          />
          {data?.type === "resident" && (
            <SimpleInput
              type="text"
              isLabel={true}
              labelText="Emirates ID"
              isRequired={false}
              value={data?.emiratesId || ""}
              onChange={() => {}}
              disabled={true}
            />
          )}
          {data?.type === "tourist" && (
            <SimpleInput
              type="text"
              isLabel={true}
              labelText="Passport ID"
              isRequired={false}
              value={data?.passportId || ""}
              onChange={() => {}}
              disabled={true}
            />
          )}
          <label className="font-size-18px font-Poppins-Regular">
            Expiry Date
          </label>
          <div className="visa-status-expiry-date">
            <SimpleInput
              type="text"
              isLabel={false}
              isRequired={false}
              value={data?.expiryDate?.split("-")[0] || ""}
              onChange={() => {}}
              placeholder="DD"
              disabled={true}
            />
            <SimpleInput
              type="text"
              isLabel={false}
              isRequired={false}
              value={data?.expiryDate?.split("-")[1] || ""}
              onChange={() => {}}
              placeholder="MM"
              disabled={true}
            />
            <SimpleInput
              type="text"
              isLabel={false}
              isRequired={false}
              value={data?.expiryDate?.split("-")[2] || ""}
              onChange={() => {}}
              placeholder="YYYY"
              disabled={true}
            />
          </div>
          <div className="visa-status-expiry-date-two">
            <div>
              <SimpleInput
                type="text"
                isLabel={true}
                labelText="Country"
                isRequired={false}
                value={data?.country || ""}
                onChange={() => {}}
                disabled={true}
              />
            </div>
          </div>
        </div>
        {data && currentStatus === "pending" && (
          <div className="flex justify-end my-6 gap-4">
            <PrimaryBtn
              ButtonText="Decline"
              btnExtraStyle={{
                backgroundColor: "#d11c1c",
                borderRadius: "1.5rem",
                padding: "6px 20px",
              }}
              onPress={() => handleRequestActions("declined", data?._id)}
              loader={isLoader === "declined"}
            />
            <PrimaryBtn
              ButtonText="Approve"
              btnExtraStyle={{
                backgroundColor: "#00443f",
                borderRadius: "1.5rem",
                padding: "6px 20px",
              }}
              onPress={() => handleRequestActions("approved", data?._id)}
              loader={isLoader === "approved"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CustomerVerification;
